import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeView from '@/views/FullPageView.vue'
import Default from '@/views/Default.vue'
Vue.use(VueRouter)

const routes = [
  {
    // Document title tag
    // We combine it with defaultDocumentTitle set in `src/main.js` on router.afterEach hook
    meta: {
      title: 'Dashboard'
    },
    path: '/',
    name: 'home',
    component: Default
  },
  {

    path: '/live/back',
    name: 'liveBack',
    component: () =>
      import( '@/views/LiveBack.vue')
  },
  {
    meta: {
      title: '直播'
    },
    path: '/live',
    component: Default
  },
  // {
  //   meta: {
  //     title: 'Tables'
  //   },
  //   path: '/tables',
  //   name: 'tables',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "tables" */ '@/views/TablesView.vue')
  // },
  {
    meta: {
      title: 'Certification',
      isLogin: false
    },
    path: '/junior-certification',
    name: 'junior-certification',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "tables" */ '@/views/CertView.vue')
  },
  {
    meta: {
      title: 'Certification',
      isLogin: false
    },
    path: '/advanced-certification',
    name: 'advanced-certification',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "tables" */ '@/views/CertView.vue')
  },
  {
    path: '/404',
    name: 'NotFound',
    meta: {
      title: 'Page not found',
      isLogin: false
    },
    component: () => import('@/views/NotFound.vue')
  },
  {
    path: '/401',
    name: 'NeedLogin',
    meta: {
      title: '需要登录后访问',
      isLogin: false
    },
    component: () => import('@/views/NotLogin.vue')
  },
  {
    meta: {
      title: 'Forms'
    },
    path: '/forms',
    name: 'forms',
    component: () =>
      import(/* webpackChunkName: "forms" */ '@/views/FormsView.vue')
  },
  {
    meta: {
      title: '学习记录',
      needLogin: true
    },
    path: '/my-course',
    name: 'my.course',
    component: () =>
      import(/* webpackChunkName: "my-course" */ '@/views/MyCourse.vue')
  },
  {
    meta: {
      title: '会员',
      needLogin: true
    },
    path: '/member',
    name: 'member',
    component: () =>
      import(/* webpackChunkName: "my-course" */ '@/views/Member.vue')
  },
  {
    meta: {
      title: 'New Client'
    },
    path: '/client/new',
    name: 'client.new',
    component: () =>
      import(
        /* webpackChunkName: "client-form" */ '@/views/ClientFormView.vue'
      )
  },
  {
    meta: {
      title: 'Edit Client'
    },
    path: '/client/:id',
    name: 'client.edit',
    component: () =>
      import(
        /* webpackChunkName: "client-form" */ '@/views/ClientFormView.vue'
      ),
    props: true
  },
  {
    meta: {
      title: '课程内容',
      needLogin: false
    },
    path: '/course/:id',
    name: 'course.view',
    component: () =>
      import(/* webpackChunkName: "client-form" */ '@/views/Course.vue'),
    props: true
  },
  {
    meta: {
      title: '章节内容',
      needLogin: true
    },
    path: '/lesson/:id',
    name: 'lesson.view',
    component: () =>
      import(/* webpackChunkName: "client-form" */ '@/views/Lesson.vue'),
    props: true
  },
  {
    meta: {
      title: '单元测验',
      needLogin: true

    },
    path: '/unit-test/:id',
    name: 'unit-test.view',
    component: () =>
      import(/* webpackChunkName: "client-form" */ '@/views/UnitTest.vue'),
    props: true
  },
  {
    meta: {
      title: '考试页面',
      needLogin: false
    },
    path: '/user-exam/:id',
    name: 'user-exam.view',
    component: () =>
      import(/* webpackChunkName: "client-form" */ '@/views/UserExam.vue'),
    props: true
  },
  {
    meta: {
      title: '备考题库',
      needLogin: true
    },
    path: '/mock-exam/:id',
    name: 'mock-exam.view',
    component: () =>
      import(/* webpackChunkName: "client-form" */ '@/views/MockExam.vue'),
    props: true
  },
  {
    meta: {
      title: '精彩案例',
      needLogin: false
    },
    path: '/cases',
    name: 'cases.view',
    component: () =>
      import(/* webpackChunkName: "client-form" */ '@/views/Cases.vue'),
    props: true
  },
  {
    meta: {
      title: '查看案例',
      needLogin: true
    },
    path: '/case/:id',
    name: 'case.view',
    component: () =>
      import(/* webpackChunkName: "client-form" */ '@/views/Case.vue'),
    props: true
  },
  {
    meta: {
      title: '精彩图库',
      needLogin: false
    },
    path: '/albums',
    name: 'albums.view',
    component: () =>
      import(/* webpackChunkName: "client-form" */ '@/views/Albums.vue'),
    props: true
  },
  {
    meta: {
      title: '直播课堂',
      needLogin: false
    },
    path: '/liveShow',
    name: 'live.view',
    component: () =>
      import(/* webpackChunkName: "client-form" */ '@/views/LiveShow.vue'),
    props: true
  },
  {
    meta: {
      title: '进入直播',
      needLogin: true
    },
    path: '/liveJump',
    name: 'live.jump',
    component: () =>
      import(/* webpackChunkName: "client-form" */ '@/views/LiveJump.vue'),
    props: true
  },
  {
    meta: {
      title: '学术会议',
      needLogin: false
    },
    path: '/news',
    name: 'news.view',
    component: () =>
      import(/* webpackChunkName: "client-form" */ '@/views/News.vue'),
    props: true
  },
  {
    meta: {
      title: '学术会议',
      needLogin: false
    },
    path: '/newsDetail',
    name: 'newsDetail.view',
    component: () =>
      import(/* webpackChunkName: "client-form" */ '@/views/NewsDetail.vue'),
    props: true
  },
  {
    meta: {
      title: '关于我们'
    },
    path: '/about',
    name: 'about.view',
    component: () =>
      import(/* webpackChunkName: "client-form" */ '@/views/About.vue'),
    props: true
  },
  {
    meta: {
      title: '修改资料',
      needLogin: true
    },
    path: '/profile',
    name: 'profile',
    component: () =>
      import(/* webpackChunkName: "profile" */ '@/views/ProfileView.vue'),
    props: true
  },
  {
    path: '/full-page',
    component: () =>
      import(/* webpackChunkName: "full-page" */ '@/views/FullPageView.vue'),
    children: [
      {
        meta: {
          title: 'Login'
        },
        path: '/login',
        name: 'login',
        component: () =>
          import(
            /* webpackChunkName: "full-page" */ '@/views/full-page/LoginView.vue'
          )
      }
    ]
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router

export function useRouter () {
  return router
}
